var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManagerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4148",
    "data-name": "Rectangle 4148",
    width: 24,
    height: 24,
    transform: "translate(-22345 12888)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_4774",
    "data-name": "Mask Group 4774",
    transform: "translate(22345 -12888)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g567",
    transform: "translate(-22342.617 12890.334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g569",
    transform: "translate(1.617 0.719)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7758",
    "data-name": "Group 7758"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g577",
    transform: "translate(5.384 6.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path579",
    d: "M-181.358-90.679a2.654,2.654,0,0,1-2.654,2.654,2.654,2.654,0,0,1-2.654-2.654,2.654,2.654,0,0,1,2.654-2.654A2.654,2.654,0,0,1-181.358-90.679Z",
    transform: "translate(186.666 93.333)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path583",
    d: "M-469.164-475.182a1.523,1.523,0,0,0,2.071-.572,1.511,1.511,0,0,0-.575-2.063l-.047-.027a1.4,1.4,0,0,1-.7-1.409,6.606,6.606,0,0,0,.061-.9,6.593,6.593,0,0,0-.068-.945,1.4,1.4,0,0,1,.7-1.414l.054-.031a1.511,1.511,0,0,0,.575-2.063,1.523,1.523,0,0,0-2.071-.572l-.066.038a1.418,1.418,0,0,1-1.588-.134,6.552,6.552,0,0,0-1.666-.971,1.415,1.415,0,0,1-.894-1.312v-.015a1.517,1.517,0,0,0-1.516-1.517,1.517,1.517,0,0,0-1.517,1.517,1.414,1.414,0,0,1-.9,1.315,6.552,6.552,0,0,0-1.685.974,1.419,1.419,0,0,1-1.586.131l-.044-.025a1.523,1.523,0,0,0-2.071.572,1.511,1.511,0,0,0,.575,2.063l.012.007a1.414,1.414,0,0,1,.707,1.428,6.592,6.592,0,0,0-.069.955,6.609,6.609,0,0,0,.064.916,1.4,1.4,0,0,1-.7,1.411l-.012.007a1.511,1.511,0,0,0-.575,2.063,1.523,1.523,0,0,0,2.071.572",
    transform: "translate(482.895 489.089)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "g585",
    transform: "translate(3.867 14.028)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path587",
    d: "M0-132.133H0A3.867,3.867,0,0,1,3.852-136h.713a3.867,3.867,0,0,1,3.852,3.867",
    transform: "translate(0 136)",
    fill: "none",
    stroke: "#9e9e9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerIcon);
export default __webpack_public_path__ + "static/media/managerIcon.c74c228568a49261dab4a13f2ad6b060.svg";
export { ForwardRef as ReactComponent };